module.exports = __webpack_public_path__ + "assets/images/rbyearend-20.jpg?v=bc04abbf";